module.exports = __webpack_public_path__ + "static/media/61-mill-valley.0eceae7f.jpg";